export default __webpack_public_path__ + "static/logo-192-765c6687689cc5749310674f957867d1.png";